import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// @ts-ignore
if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
  // @ts-ignore
  window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = () => {};
}

// Отключаем overlay с ошибками
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    args[0].includes("React will try to recreate")
  ) {
    return;
  }
  originalConsoleError(...args);
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

reportWebVitals();
